import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

// Set up axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Crucial for sending/receiving cookies
  headers: {
    "Content-Type": "application/json",
  },
});

// We still send the token header as a fallback for backwards compatibility,
// but the backend prioritizes cookies now.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Automatic token refresh logic
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // If we get a 401 Unauthorized and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Try to refresh token
        await axios.post(`${API_BASE_URL}/refresh-token`, {}, { withCredentials: true });
        // If successful, retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // If refresh fails, we are truly logged out.
        // Optional: you could clear localStorage or redirect to login here.
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// API Functions
export const signup = (userData) => {
  const config = userData instanceof FormData ? { headers: { "Content-Type": "multipart/form-data" } } : {};
  return api.post("/signup", userData, config).then((response) => response.data);
};

export const checkUsername = (username) =>
  api.get(`/check-username?username=${username}`).then((response) => response.data);

export const login = (credentials) =>
  api.post("/login", credentials).then((response) => response.data);

export const logoutUser = () => 
  api.post("/logout").then(res => res.data);

export const getMe = () => 
  api.get("/me").then(res => res.data);

export const updateProfile = (data) => {
  const config = data instanceof FormData ? { headers: { "Content-Type": "multipart/form-data" } } : {};
  return api.post("/update-profile", data, config).then((res) => res.data);
};

export const getUsers = () =>
  api.get("/users").then((response) => response.data);

export const getChatList = () =>
  api.get("/chat-list").then((response) => response.data);

